<div class="adm-form-page">
  <div class="adm-form-page__inner">
    <div class="adm-form-card">

      <div class="adm-form-card__header">
        <div class="adm-form-card__header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <div>
          <h1 class="adm-form-card__title">Editer un agent</h1>
          <!-- edit : Modifier un agent -->
          <p class="adm-form-card__subtitle">Renseignez les informations de l'agent.</p>
        </div>
      </div>

      <form [formGroup]="entityForm" (ngSubmit)="onEditEntity()" class="adm-form-card__body">
        <!-- edit : (ngSubmit)="onEditEntity()" -->

        <div class="adm-form__section">
          <p class="adm-form__section-title">Identité</p>
          <div class="adm-form__row">
            <app-input formControlName="nom" type="text" label="Nom *"/>
            <app-input formControlName="prenoms" type="text" label="Prénoms *"/>
          </div>
          <div class="adm-form__row">
            <app-select label="Sexe" [options]="sexes" formControlName="sexe"/>
            <app-input formControlName="dateNaissance" type="date" label="Date de naissance *"/>
          </div>
        </div>

        <div class="adm-form__section">
          <p class="adm-form__section-title">Contact</p>
          <div class="adm-form__row">
            <app-input formControlName="email" type="email" label="Email *"/>
            <app-input formControlName="emailPro" type="email" label="Email professionnel *"/>
          </div>
          <div class="adm-form__row">
            <app-input formControlName="telephone" type="text" label="Téléphone *"/>
            <app-input formControlName="adresse" type="text" label="Adresse *"/>
          </div>
        </div>

        <div class="adm-form__section">
          <p class="adm-form__section-title">Affectation</p>
          <div class="adm-form__row">
            <app-select label="Structure" [options]="structures" formControlName="strucutre"/>
            <app-select label="Poste" [options]="postes" formControlName="poste"/>
          </div>
          <app-input formControlName="datePriseService" type="date" label="Date de prise de service *"/>
        </div>

        <div class="adm-form__actions">
          <app-ui-button
            label="Retour"
            variant="ghost"
            size="md"
            type="button"
            iconLeft="arrow_back"
            [routerLink]="['/', routeAlias.administration.home, routeAlias.administration.agent.home]"
          ></app-ui-button>
          <app-ui-button
            label="Enregistrer"
            variant="primary"
            size="md"
            iconLeft="save"
            type="submit"
            [loading]="isLoading"
            [disabled]="isLoading || entityForm.invalid"
          ></app-ui-button>
          <!-- edit : label="Mettre à jour" iconLeft="check" -->
        </div>

      </form>
    </div>
  </div>
</div>